// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Reducer$LiteracyplanetTupperware from "../Reducer.res.mjs";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as V2ExerciseStateStoreContext$LiteracyplanetTupperware from "../v2/V2ExerciseStateStoreContext.res.mjs";

function V3ClozeChoiceProvider(props) {
  var questionIndex = props.questionIndex;
  var match = V2ExerciseStateStoreContext$LiteracyplanetTupperware.useDispatch();
  var dispatch = match[1];
  var match$1 = V2ExerciseContext$LiteracyplanetTupperware.use();
  var getStep = match$1.getStep;
  var answerVisible = match$1.isCorrectAnswerVisible(questionIndex);
  var getMarkType = function (id) {
    return Reducer$LiteracyplanetTupperware.getMarkTypeWip(getStep(questionIndex), id);
  };
  var findDroppedId = function (id) {
    return Reducer$LiteracyplanetTupperware.mapDropId(Reducer$LiteracyplanetTupperware.mapIdPair(getStep(questionIndex), (function (param, dragId) {
                      return dragId === id;
                    })));
  };
  var isDropped = function (id) {
    return Belt_Option.isSome(Reducer$LiteracyplanetTupperware.mapIdPair(getStep(questionIndex), (function (dropId, param) {
                      return dropId === id;
                    })));
  };
  var findCorrectResponse = function (id, _index) {
    var match = getStep(questionIndex);
    if (typeof match !== "object") {
      return ;
    }
    if (match.TAG === "Attempted") {
      return ;
    }
    var tmp = match._0;
    if (typeof tmp !== "object") {
      return ;
    } else {
      return Caml_option.some(id);
    }
  };
  var onUndoDrop = function (drag, drop) {
    if (Reducer$LiteracyplanetTupperware.isMarked(getStep(questionIndex))) {
      return ;
    } else {
      return dispatch({
                  TAG: "DeleteResponseIdentifier",
                  _0: questionIndex,
                  _1: {
                    TAG: "IdPair",
                    _0: drop,
                    _1: drag
                  }
                });
    }
  };
  var onDrop = function (drag, drop, _index) {
    if (Reducer$LiteracyplanetTupperware.isMarked(getStep(questionIndex))) {
      return ;
    } else {
      return dispatch({
                  TAG: "SetQuestionState",
                  _0: questionIndex,
                  _1: {
                    TAG: "SetResponse",
                    _0: {
                      TAG: "BoolResponsePayload",
                      _0: {
                        TAG: "IdPair",
                        _0: drop,
                        _1: drag
                      }
                    }
                  },
                  _2: "ResponseMarking"
                });
    }
  };
  return React.createElement(V3DndBehaviour$LiteracyplanetTupperware.DndProvider.make, {
              api: {
                findDroppedId: findDroppedId,
                isDropped: isDropped,
                findCorrectResponse: findCorrectResponse,
                answerVisible: answerVisible,
                getMarkType: getMarkType,
                onUndoDrop: onUndoDrop,
                onDrop: onDrop,
                overClassName: props.overClassName,
                dropClassName: props.dropClassName,
                renderDragComponent: props.renderDragComponent,
                renderDragOverlayComponent: props.renderDragOverlayComponent,
                renderAlreadyDraggedPlaceholder: props.renderAlreadyDraggedPlaceholder,
                renderAlreadyDraggedAndMarkedPlaceholder: props.renderAlreadyDraggedAndMarkedPlaceholder,
                renderDroppedComponent: props.renderDroppedComponent,
                renderCorrectDroppedComponent: props.renderCorrectDroppedComponent,
                renderIncorrectDroppedComponent: props.renderIncorrectDroppedComponent,
                renderUndroppedMarkedComponent: props.renderUndroppedMarkedComponent
              },
              children: props.children
            });
}

var make = V3ClozeChoiceProvider;

export {
  make ,
}
/* react Not a pure module */
